<template>
  <div id="template">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form
        :ref="form"
        :model="form"
        label-width="80px"
        style="padding: 0 5px"
      >
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="模板编号：">
                <el-input
                  size="small"
                  v-model="form.templateId"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="模板名称：">
                <el-input
                  size="small"
                  v-model="form.templateName"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="创建时间：" prop="dateValue">
                <el-date-picker
                  size="small"
                  v-model="dateValue"
                  style="width: 100%;"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                >
                </el-date-picker>
                <div style="text-align: right;margin: auto;padding-top: 10px;">
                  <el-button size="small" type="primary" @click="getList"
                    >搜索</el-button
                  >
                  <el-button size="small" @click="resetForm">重置</el-button>
                </div>
              </el-form-item>
            </div></el-col
          >
        </el-row>
      </el-form>
    </div>
    <div class="form-body">
      <div class="form-body-header">
        <div class="left">
          <el-button
            style="float:left;margin: 6px 0 0 0;"
            size="small"
            type="primary"
            @click="handleCreateTemplate"
            >新增模板</el-button
          >
          <div style="float:left;">
            <el-upload
              class="upload-task"
              action=""
              ref="uploadControl"
              :http-request="uploadFile1"
              :on-success="(value) => handleUploadSuccess1(value)"
              :show-file-list="true"
              :file-list="fileList1"
              :before-upload="beforeUpload"
              :limit="1"
              size="small"
            >
              <el-button icon="el-icon-plus" type="primary" size="small"
                >自定义模板</el-button
              >
            </el-upload>
          </div>
        </div>
        <div class="right">
          <pagination
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
      <el-table
        id="outTable"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        lazy
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          prop="templateId"
          label="模板编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="templateName"
          label="模板名称"
          align="center"
        ></el-table-column>
        <el-table-column prop="templateState" label="模板国家" align="center">
          <template slot-scope="scope">
            {{ dictMap["amazon_site"][scope.row.templateState] }}
          </template>
        </el-table-column>
        <el-table-column prop="templateState" label="售卖方式" align="center">
          <template slot-scope="scope">
            {{ dictMap["sale_form"][scope.row.saleForm] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="itemSku"
          label="产品编号"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作人"
          align="center"
          prop="nickName"
          width="120"
        >
         <template slot-scope="scope">
            {{ scope.row.nickName ?  scope.row.nickName : scope.row.operNo}}
          </template>
        </el-table-column>
        <el-table-column prop="tTime" label="时间" align="center">
          <template slot-scope="scope">
            <div style="text-align:left;">创建：{{ scope.row.createTime }}</div>
            <div style="text-align:left;">更新：{{ scope.row.updateTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="handel" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.remark == '1'"
              type="text"
              size="mini"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="mini" @click="handleCopy(scope.row)"
              >复制模板</el-button
            >
            <el-button
              v-if="scope.row.remark == '1'"
              type="text"
              size="mini"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
            <br />
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
      </el-table>
      <pagination
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="getList"
      />
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="上传模板"
      v-show="uploadModalVisible"
    >
      <el-form
        :model="editDialog.advisoryForm"
        :rules="editDialog.rules"
        ref="advisoryForm"
        label-width="140px"
      >
        <el-form-item label="上传模板" prop="">
          <el-upload
            ref="upload"
            action="#"
            :file-list="editDialog.fileList"
            :auto-upload="false"
            :on-change="handleChange"
            :multiple="false"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选择文件</el-button
            >
            <div slot="tip" class="el-upload__tip">
              文件小于20M
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="uploadModalVisible = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="handleUploadForm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { listPlatType, uploadTemplate } from "@/api/plat/platType"
import Breadcrumb from "@/components/common/Breadcrumb";
import { getTemplateList, delTemplate } from "@/api/template/template";
import { mapGetters } from "vuex";

export default {
  name: "onLine",
  components: { Breadcrumb },
  data() {
    return {
      selectValue1: "",
      total: 0,
      currentPage: 1,
      pickerOptions: {},
      form: {
        pageNum: 1,
        pageSize: 10,
        templateId: '',
        beginTime: null,
        endTime: null,
      },
      dateValue: [],
      pickerOptions: {},
      tableData: [],
      uploadModalVisible: true,
      editDialog: {
        advisoryForm: {
        },
        fileList: [],
        rules: {
        }},
      fileList1: [],
    };
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
      routeName() {
      return this.$route.path
    },
  },
  watch: {
      routeName() {
      this.resetForm()
      this.getList()
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList(){
      if(this.dateValue && this.dateValue.length > 0){
        this.form.beginTime = this.dateValue[0]
        this.form.endTime = this.dateValue[1]
      } else{
        this.form.beginTime = null
        this.form.endTime = null
      }
      getTemplateList(this.form).then((result)=>{
        this.tableData = result.rows
      })
    },
    handleCreateTemplate(){
      this.$router.push({
        path: '/carry/amazon/createTemplate',
        query: {action: 'new'}
      })
    },
    handleEdit(row){
      this.$router.push({
        path: '/carry/amazon/createTemplate',
        query: {templateId: row.templateId, platId: row.platId, action: 'edit'}
      })
    },
    handleCopy(row){
        this.$router.push({
        path: '/carry/amazon/createTemplate',
        query: {templateId: row.templateId, platId: row.platId, action: 'copy'}
      })
    },
    handleDelete(row){
      this.$confirm('确认删除模板吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await delTemplate(row.templateId)
          this.getList()
          this.$message.success('删除成功');
        }).catch(() => {
        });
    },
    handleShowUpload(){
      this.uploadModalVisible = true
    },
    handleChange(file, fileList) {
      if(file.size > 20*1024*1024){
        this.msgWarning("文件不能大于20M")
        this.editDialog.fileList = []
      }else{
        this.editDialog.fileList = [file]
      }
    },
    handleUploadForm(){

    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error("文件超过2MB")
      }
      return isLt2M
    },
    async uploadFile1(file) {
      this.startLoading()
      let formData = new FormData()
      formData.append("file", file.file)
      uploadTemplate(formData).then((response) => {
        if (response.code === 200) {
          this.$router.push({
            path: '/carry/amazon/createTemplate',
            query: {
              action: 'new',
              platId: response.msg
            }
          })
          this.msgSuccess("导入成功")
          this.endLoading()
        } else {
          this.msgError(response.msg)
          this.endLoading()
        }
      }).catch(()=>{
        this.endLoading()
      })
    },
    handleUploadSuccess1(response) {
      this.$refs.uploadControl.clearFiles()
    },

    resetForm(){
      this.form = {
        pageNum: 1,
        pageSize: 10,
        templateId: '',
        beginTime: null,
        endTime: null,
      },
      this.dateValue = []
    }
  },
  mounted() {},
};
</script>

<style scoped>
@import "../../../assets/css/product.css";
#ready-release {
  width: 100%;
}
.detailForm {
  padding-top: 5px;
  margin-left: 85px;
  width: 50%;
  height: auto;
  margin-bottom: 8px;
}
.detailForm .el-form-item,
.sea_cont {
  margin-bottom: 10px !important;
}
.double_item .el-form-item {
  margin-bottom: 0px !important;
}
.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.form-content {
  background: #ffffff;
}
.upload-task {
  display: inline-block;
  margin: 0 0 0 16px;
}
</style>
